// @ts-check
/** @import OptionGroupMixin from './option-group-mixin.js' */

/** @param {{ new(): HTMLElement }} [Base] */
export default (Base = HTMLElement) =>
  class OptionGroupWrapperMixin extends Base {
    static get observedAttributes() {
      return ["name", "value"];
    }

    static get eventListenName() {
      return "option-value-change";
    }

    #instanceConstructor;

    constructor() {
      super();
      this.#instanceConstructor = new.target;
    }

    connectedCallback() {
      super['connectedCallback']?.();
      this.optionGroup.addEventListener(this.#instanceConstructor.eventListenName, (e) => this.handleValueChange(e));
    }

    /** @param {string} name @param {string | null} oldValue @param {string | null} newValue */
    attributeChangedCallback(name, oldValue, newValue) {
      super['attributeChangedCallback']?.(name, oldValue, newValue);
      if (name === "name" || name === "value") {
        setAttr(this.optionGroup, name, newValue);
      }
    }

    /** @returns {InstanceType<ReturnType<OptionGroupMixin>>} */
    get optionGroup() {
      throw new Error("OptionGroupWrapperMixin: optionGroup getter must be overwritten in subclass");
    }

    get value() {
      return this.getAttribute("value");
    }

    set value(value) {
      setAttr(this, "value", value);
    }

    get values() {
      return this.optionGroup.values || [];
    }

    get name() {
      return this.getAttribute("name");
    }

    set name(value) {
      setAttr(this, "name", value);
    }

    get disabledValues() {
      return this.optionGroup.disabledValues || [];
    }

    set disabledValues(values) {
      customElements.whenDefined(this.optionGroup.localName).then(() => {
        this.optionGroup.disabledValues = values;
      });
    }

    get lightningDealValues() {
      return this.optionGroup.lightningDealValues || [];
    }

    set lightningDealValues(values) {
      customElements.whenDefined(this.optionGroup.localName).then(() => {
        this.optionGroup.lightningDealValues = values;
      });
    }

    /** @param {Event} e */
    handleValueChange(e) {
      if (e instanceof CustomEvent && (e.detail.value === null || typeof e.detail.value === "string")) {
        this.value = e.detail.value;
      }
    }
  };


/** @param {HTMLElement} el @param {string} name @param {string | null} value */
function setAttr(el, name, value) {
  if (value === null) {
    el.removeAttribute(name);
  } else {
    el.setAttribute(name, value);
  }
}